import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import ja from './locales/ja.json';
import pt from './locales/pt.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
  ja: { translation: ja },
  pt: { translation: pt }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸', currency: 'USD' },
  { code: 'es', name: 'Español', flag: '🇪🇸', currency: 'EUR' },
  { code: 'fr', name: 'Français', flag: '🇫🇷', currency: 'EUR' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪', currency: 'EUR' },
  { code: 'ja', name: '日本語', flag: '🇯🇵', currency: 'JPY' },
  { code: 'pt', name: 'Português', flag: '🇧🇷', currency: 'BRL' }
];

export const currencyRates = {
  USD: 1,
  EUR: 0.92,
  JPY: 149.50,
  BRL: 4.97,
  GBP: 0.79
};

export const formatCurrency = (amount, currencyCode = 'USD') => {
  const formatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: currencyCode === 'JPY' ? 0 : 2
  });
  
  const rate = currencyRates[currencyCode] || 1;
  return formatter.format(amount * rate);
};

export default i18n;
